/*
 * Created by guandong.ni on 17/10/27.
 * toast提示,
 */
export default function(txt, opts) {
  let settings = Object.assign({
    noClose: true,
  }, opts);
  if (!window.toastDom) {
    require('./assets/css/toast.css');
    let html = `<div class="toast ani_opacity">
					<div class="infobox">
						<div class="box">
							<a class="close" href="javascript:"/>
							<p style="line-height: 1.5"/>
						</div>
					</div>
				</div>`;
    let toastDom = window.toastDom = $(html).appendTo('body');
    toastDom.find('.close').bind('click', (e) => {
      $('html,body').removeClass('no-scroll')
      toastDom.removeClass('toastshow');
      toastDom.clearTimeout();
    });
    toastDom.setText = function(txt) {
      this.find('p').html(txt);
      return this;
    };
    toastDom.clearTimeout = function() {
      if (this.ani) {
        clearTimeout(this.ani);
        this.ani = null;
      }
      return this;
    };
  }
  let toastDom = window.toastDom;
  toastDom.clearTimeout().addClass('toastshow').setText(txt);
  $('html,body').addClass('no-scroll')
  if (settings.noClose) {
    toastDom.find('.close').hide();
  } else {
    toastDom.find('.close').show();
  }
	toastDom.ani = setTimeout(() => {
		$('html,body').removeClass('no-scroll')
		toastDom.removeClass('toastshow');
		toastDom.ani = null;
	}, 2000);
}



// WEBPACK FOOTER //
// ./src/component/common/toast.jquery.js